import "@/App.css";
import { useState } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppLayout from "@/components/AppLayout";
import SplashScreen from "@/components/SplashScreen";
import LoginPage from "@/pages/LoginPage";
import CaptureHubPage from "@/pages/CaptureHubPage";
import LeadDetailPage from "@/pages/LeadDetailPage";
import DashboardPage from "@/pages/DashboardPage";
import KallitagLeadsPage from "@/pages/KallitagLeadsPage";
import AdminPage from "@/pages/AdminPage";
import ReunionsPage from "@/pages/ReunionsPage";
import MeetingReportPage from "@/pages/MeetingReportPage";
import TeamChatPage from "@/pages/TeamChatPage";
import LandingPage from "@/pages/LandingPage";
import PrivacyPage from "@/pages/PrivacyPage";
import MentionsLegalesPage from "@/pages/MentionsLegalesPage";
import TermsPage from "@/pages/TermsPage";
import DpaPage from "@/pages/DpaPage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import SubscribePage from "@/pages/SubscribePage";
import PaymentSuccessPage from "@/pages/PaymentSuccessPage";
import PaymentCancelPage from "@/pages/PaymentCancelPage";
import ConsentBanner from "@/components/ConsentBanner";
import PublicCapturePage from "@/pages/PublicCapturePage";
import QuoteSignPage from "@/pages/QuoteSignPage";
import ProduitPage from "@/pages/ProduitPage";
import MeetingsPage from "@/pages/MeetingsPage";
import TresoreriePage from "@/pages/TresoreriePage";
import ChantiersPage from "@/pages/ChantiersPage";
import CardPage from "@/pages/CardPage";
import CardEditorPage from "@/pages/CardEditorPage";
import BrandingPage from "@/pages/BrandingPage";

function App() {
  const [showSplash, setShowSplash] = useState(() => !sessionStorage.getItem("klt_splash_seen") && !window.location.pathname.startsWith("/devis/"));

  return (
    <div className="App">
      {showSplash && (
        <SplashScreen onDone={() => { sessionStorage.setItem("klt_splash_seen", "1"); setShowSplash(false); }} />
      )}
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/decouvrir" element={<LandingPage />} />
            <Route path="/produit" element={<ProduitPage />} />
            <Route path="/confidentialite" element={<PrivacyPage />} />
            <Route path="/mentions-legales" element={<MentionsLegalesPage />} />
            <Route path="/cgu" element={<TermsPage />} />
            <Route path="/dpa" element={<DpaPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route path="/c/:slug" element={<PublicCapturePage />} />
            <Route path="/devis/:token" element={<QuoteSignPage />} />
            <Route path="/card/:slug" element={<CardPage />} />
            <Route path="/abonnement" element={<SubscribePage />} />
            <Route path="/payment/success" element={<PaymentSuccessPage />} />
            <Route path="/payment/cancel" element={<PaymentCancelPage />} />
            <Route
              element={
                <ProtectedRoute>
                  <AppLayout />
                </ProtectedRoute>
              }
            >
              <Route path="/" element={<CaptureHubPage />} />
              <Route path="/quotidien" element={<MeetingsPage />} />
              <Route path="/tresorerie" element={<TresoreriePage />} />
              <Route path="/chantiers" element={<ChantiersPage />} />
              <Route path="/ma-carte" element={<CardEditorPage />} />
              <Route path="/branding" element={<BrandingPage />} />
              <Route path="/lead/:id" element={<LeadDetailPage />} />
              <Route path="/lead/new" element={<LeadDetailPage />} />
              <Route path="/dashboard" element={<DashboardPage />} />
              <Route path="/kallitag-leads" element={<KallitagLeadsPage />} />
              <Route path="/admin" element={<AdminPage />} />
              <Route path="/reunions" element={<ReunionsPage />} />
              <Route path="/reunions/:id" element={<MeetingReportPage />} />
              <Route path="/equipe" element={<TeamChatPage />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster position="top-center" richColors />
          <ConsentBanner />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
